import { useState } from "react";

const COPIED_FEEDBACK_MS = 1500;

/** Copia texto e expoe qual chave foi copiada (feedback temporario) e falha. */
export function useClipboard() {
  const [copiedKey, setCopiedKey] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  const copy = async (text: string, key = "default"): Promise<boolean> => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedKey(key);
      setFailed(false);
      window.setTimeout(() => setCopiedKey(null), COPIED_FEEDBACK_MS);
      return true;
    } catch {
      setFailed(true);
      return false;
    }
  };

  return { copiedKey, failed, copy };
}
